export const IS_HIDDEN_WELCOME_SCREEN_COOKIE = 'isHiddenWelcomeScreen'
export const ADVERT_INFO_COOKIE = 'advert-info'
